import Page from "../common/page/Page"
import style from "./Policies.module.css"

const ShippingPolicy = () => {
  return (
    <Page title="Shipping Policy" searchDisabled={true}>
      <div className={style.policyContainer}>
        {/* Luxury Hero Banner */}
        <div className={style.heroHeader}>
          <h1>Shipping Policy</h1>
          <p className={style.heroSubtitle}>
            Details on domestic processing times, estimates, and courier support.
          </p>
        </div>

        {/* Content Card */}
        <div className={style.sectionCard}>
          <h2>Shipping Policy</h2>

          <h3>Order Processing Time</h3>
          <p>
            All orders are processed within <strong>6 to 10 business days</strong>{" "}
            (excluding weekends and holidays) after receiving your order
            confirmation email.
          </p>
          <p>
            Please note that delays may occur due to a high volume of orders or
            issues with postal services that are beyond our control.
          </p>
          <p>
            If you do not receive your product within{" "}
            <strong>4 days after the dispatch date</strong>, please inform us by
            emailing{" "}
            <a href="mailto:dr.mmherbalsenquiry@gmail.com">
              dr.mmherbalsenquiry@gmail.com
            </a>
            .
          </p>

          <h3>Domestic Shipping Rates and Estimates</h3>
          <p>
            For calculated shipping rates: Shipping charges for your order will be
            calculated and displayed at checkout.
          </p>
        </div>
      </div>
    </Page>
  )
}

export default ShippingPolicy
